<template>
    <div class="tab-account-setting">
        <div class="blockcont">
            <div class="explain" style="margin-top: -20px; margin-bottom: 10px !important;"><em>Changes in group setting require approval by all Board Member(s) of the group before the changes are applied. The approval process is similar to voting process. Board member(s) would receive a notification on his/her profile and a link to the page to review the request for change. </em>
            </div>
            <div class="blockcont">
                <div class="smalltitle unapprovedwrap">Group type</div>
                <div class="explain"><em>Close group meaning only confirmed members can see your profile and posts.</em>
                </div>
                <div class="prolabel">Group type</div>
                <div class="profield checkbox">
                    <input :disabled="disabledForm" v-model="groupInfo.type" name="open" type="radio" value="open"
                           id="openchoice"><label for="openchoice">Public group</label>
                    <input :disabled="disabledForm" v-model="groupInfo.type" name="open" type="radio" value="close"
                           id="closechoice"><label for="closechoice">Private group</label></div>
            </div>

            <div class="blockcont">
                <div class="smalltitle unapprovedwrap">
                    Posting options
                </div>

                <div class="profield checkbox">
                    <input :disabled="disabledForm" v-model="postingOption.postingOption"
                           name="postingOption" type="radio" value="1" id="openchoice1"><label for="openchoice1">Primary account only</label>
                    <input :disabled="disabledForm" v-model="postingOption.postingOption"
                           name="postingOption" type="radio" value="2" id="openchoice2"><label for="openchoice2">Primary and members</label>
                    <input :disabled="disabledForm" v-model="postingOption.postingOption"
                           name="postingOption" type="radio" value="3" id="openchoice3"><label for="openchoice3">Everyone</label>
                </div>
            </div>

            <div class="blockcont">
                <div class="smalltitle">
                    Account Setting
                </div>
                <form id="form_update_group">
                    <div class="prolabel">Sign-in Email address</div>
                    <div class="profield">
                        <input type="text" v-model="userInfo.email" maxlength="50" :disabled="disabledForm"><br>
                        <div class="explain">
                            <em>Email address is your sign-in ID, change it will change your sign-in info too.</em>
                        </div>
                    </div>

                    <div class="prolabel">Private Phone number</div>
                    <div class="profield">
                        <input type="text" :value="userInfo.phoneRecovery | formatPhone" maxlength="15" :disabled="disabledForm"><br>
                        <div class="explain"><em>Recovery phone number. In case lost of email, you can retrieve your sign-in with this number.</em>
                        </div>
                    </div>

                    <div class="prolabel">WikiAllergies email</div>
                    <div class="profield"><input type="text" :value="userInfo.wikiEmail" disabled="disabled"></div>
                    <div class="prolabel">Tax ID (EIN) </div>
                    <div class="profield"><input v-model="userInfo.taxid" type="text" :disabled="disabledForm"></div>
                    <div class="prolabel"></div>
                </form>
            </div>
            <payment-setting-group-block
                    :payments="payments"
                    :addressBillings="addressBillings"
                    :checkingAccounts="checkingAccounts"
                    :disabledForm="disabledForm">
            </payment-setting-group-block>
        </div>
    </div>
</template>

<script>

import DetailRegularUserMixin from '../../../../mixins/user/UserStatusMixin.vue'
import PaymentSettingGroupBlock from './PaymentSettingGroupBlock.vue'

export default {
  name: 'TabAccountSetting',
  components: { PaymentSettingGroupBlock },
  props: {
    userInfo: {},
    payments: {},
    addressBillings: {},
    disabledForm: {},
    profile: {},
    checkingAccounts: {}
  },
  mixins: [DetailRegularUserMixin],
  data () {
    return {
      groupInfo: {
        type: 'open'
      },
      postingOption: {
        postingOption: 1
      }
    }
  },
  computed: {},
  watch: {
    'profile' (newVal, oldVal) {
      this.initData()
    }
  },
  updated () {
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
    initData () {
      if (this.profile) {
        this.groupInfo.type = this.profile.type
        this.postingOption.postingOption = this.profile.postingOption
        console.log(this.checkingAccounts, '22')
      }
      this.$forceUpdate()
    }
  }
}
</script>
<style scoped="">

</style>
